import { CloseButton, Modal } from "react-bootstrap";
import { GetNotCompliedApplicationsInstancesProcess } from "../../../client/AuthedClient";
import { Table } from "../../Table";
import { ConverToLocalAndFormat } from "../../../utils/Date-Time-Util/DateTimeFormater";

export const ApplicationsComplianceDetailsModal = ({
  details,
  lgShow,
  setLgShow,
  modalTitle,
  pdfTitle,
}: {
  details: Array<GetNotCompliedApplicationsInstancesProcess>;
  lgShow: boolean;
  setLgShow: (lgShow: boolean) => void;
  modalTitle: string;
  pdfTitle: string;
}) => {
  const columns = [
    { name: "Device Name", attr: "computerName" },
    { name: "Installation Date", attr: "installationDate" },
  ];

  const rowStrings = {
    key: "computerName",
    items: details.map((detail) => [detail.computerName]),
  };
  const rows = (array: Array<GetNotCompliedApplicationsInstancesProcess>) => {
    return array.map((details, index) => (
      <tr key={index}>
        <td>{details.computerName}</td>
        <td>
          {details.installationDate
            ? ConverToLocalAndFormat(details.installationDate, "dd/MM/yyyy")
            : "-"}
        </td>
      </tr>
    ));
  };
  const excelDate = details?.map((item: any) => {
    return {
      computerName: item.computerName === null ? "-" : item.computerName,
      installationDate:
        item.installationDate === null
          ? "-"
          : ConverToLocalAndFormat(item.installationDate, "M/D/YYYY"),
    };
  });
  return (
    <Modal
      className={`${lgShow ? "popUpModal details-modal-opened" : "popUpModal"}`}
      keyboard={false}
      centered={true}
      scrollable={true}
      onHide={() => setLgShow(false)}
      show={lgShow}
      size="lg"
    >
      <div className="modal-content">
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <CloseButton
            onClick={() => {
              setLgShow(false);
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <Table
            pageTitle={`${pdfTitle} Application Details`}
            rows={rows}
            rowsData={details}
            columns={columns}
            rowsStrings={rowStrings}
            excelData={excelDate}
          />
        </Modal.Body>
      </div>
    </Modal>
  );
};
